export default "__VITE_ASSET__0c6be7ad__"